module.exports = __webpack_public_path__ + "static/media/paint-brush-icon.97a4628b.svg";